import { AppLayout } from './index';

const {
  AppContentView,
  AppFooter,
  AuthorizedRoute,
  LandingPageWithLinks,
  MainApplicationProviderWrapper,
} = AppLayout;

export {
  AppContentView,
  AppFooter,
  AuthorizedRoute,
  LandingPageWithLinks,
  MainApplicationProviderWrapper,
};
